export default __webpack_public_path__ + "static/media/logo_old.19f0fb61.png";